import { Button, Spin } from 'antd'
import './FacilityTourismTabs.less'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import useStore from '@/hooks/useStore'

function FacilityTourismTabs() {
  const facilityStore = useStore('facilityStore')
  const [result1Show, setResult1Show] = useState(true)
  const [Loading1, setLoading1] = useState(false)
  const [result2Show, setResult2Show] = useState(true)
  const [Loading2, setLoading2] = useState(false)
  const [FarmTurmData, setFarmTurmData] = useState<any>([])
  const [FarmStyData, setFarmStyData] = useState<any>([])
  const [moreOne, setMoreOne] = useState(true)
  const [moreTwo, setMoreTwo] = useState(true)
  useEffect(() => {
    setLoading1(true)
    setLoading2(true)
    setFarmTurmData([])
    setFarmStyData([])
    facilityStore.queryPrteFarmTurmInfo().then((res: any) => {
      if (res.code === 200) {
        if (res.result.length > 0) {
          setFarmTurmData(res.result)
          setLoading1(false)
        }
        else {
          setLoading1(false)
          setResult1Show(false)
        }
      }
      else {
        setLoading1(false)
        setResult1Show(false)
      }
    })

    facilityStore.queryPrteFarmStyInfo().then((res: any) => {
      if (res.code === 200) {
        if (res.result.length > 0) {
          setFarmStyData(res.result)
          setLoading2(false)
        }
        else {
          setLoading2(false)
          setResult2Show(false)
        }
      }
      else {
        setLoading2(false)
        setResult2Show(false)
      }
    })
  }, [facilityStore.FacilityLeaseInfo])

  const moreCilckOne = () => {
    setMoreOne(false)
  }

  const moreCilckTwo = () => {
    setMoreTwo(false)
  }

  return (
                    <div className={'FacilityTourismTabs'}>
                            <div className={'tourism-inner'}>
                              <div className={'program-info'}>
                              <div className={'program-info-title'}>
                                <strong>체험프로그램</strong>
                                <a>반경 2km</a>
                                </div>
                                {
                                  result1Show
                                    ? (<Spin tip="검색..." size="large" spinning={Loading1}>
                                        <ul className={'program-list'} style={{ height: moreOne ? '500px' : 'auto' }}>
                                          {
                                            FarmTurmData.map((item: any, index: any) => (
                                                <li className={'program-item'} key={index}>
                                                  <img className={'imgPart'} alt={item.exprnNm} src={item.exprnThmb} />
                                                  <em className={'title'}>{item.exprnNm}</em>
                                                  <p className={'text'}>{item.exprnAddr}</p>
                                                </li>
                                            ))
                                          }
                                        </ul>
                                        {
                                            moreOne
                                            && <Button onClick={moreCilckOne} className={'buttonPart'} size={'small'}>더보기 + </Button>
                                        }
                                      </Spin>)
                                    : (
                                          <div className={'not-info'}>
                                           결과가 없습니다.
                                          </div>
                                      )
                                }
                              </div>
                              <div className={'program-info lodgment-info'}>
                              <div className={'program-info-lodgment'}>
                                <strong>숙박시설정보</strong>
                                <a>반경 2km</a>
                                </div>
                                {
                                  result2Show
                                    ? (
                                         <Spin tip="검색..." size="large" spinning={Loading2}>
                                           <ul className={'program-list'} style={{ height: moreTwo ? '500px' : 'auto' }}>
                                             {
                                               FarmStyData.map((item: any, index: any) => (
                                                   <li className={'program-item'} key={index}>
                                                     <img className={'imgPart'} alt={item.styiNm} src={item.styiThmb} />
                                                     <em className={'title'}>{item.styiNm}</em>
                                                     <p className={'text'}>{item.addr}</p>
                                                   </li>
                                               ))
                                             }
                                           </ul>
                                           {
                                               moreTwo
                                               && <Button onClick={moreCilckTwo} className={'buttonPart'} size={'small'}>더보기 + </Button>
                                           }
                                         </Spin>
                                      )
                                    : (
                                          <div className={'not-info'}>
                                             결과가 없습니다.
                                          </div>
                                      )
                                }
                              </div>
                            </div>
                  </div>
  )
}
export default observer(FacilityTourismTabs)
